var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.classes,style:(_vm.styles)},[_c('use',_vm._b({},'use',{'xlink:href':'#icon-tx4_'+ _vm.usedIcon.trim()},false))])
}
var staticRenderFns = []

export { render, staticRenderFns }